/** Partner console — Commissions ledger. */
import { useTranslation } from "react-i18next";
import { formatDate } from "@/lib/format";

import { PartnerPageHeader } from "@/components/PartnerLayout";
import { usePartnerCommissions } from "@/lib/partner";

export default function PartnerCommissionsPage() {
  const { t } = useTranslation();
  const commissions = usePartnerCommissions();

  return (
    <>
      <PartnerPageHeader
        eyebrow={t("nav.partner.commissions")}
        title={t("partner.commissions.title")}
        description={t("partner.commissions.lead")}
        action={
          commissions.data ? (
            <div className="text-right text-sm">
              <div className="text-xs text-nb-text-3">
                {t("partner.kpi.unpaid")}
              </div>
              <div className="text-lg font-semibold text-nb-mint">
                €{commissions.data.unpaid_total_eur}
              </div>
            </div>
          ) : undefined
        }
      />

      <section className="card space-y-2">
        {commissions.isLoading ? (
          <p className="text-sm text-nb-text-3">{t("common.loading")}</p>
        ) : !commissions.data || commissions.data.entries.length === 0 ? (
          <p className="text-sm text-nb-text-3">{t("partner.commissions.noneYet")}</p>
        ) : (
          <table className="w-full text-left text-sm">
            <thead className="text-xs uppercase text-nb-text-3">
              <tr>
                <th className="py-1">{t("partner.commissions.colPeriod")}</th>
                <th className="py-1">{t("partner.commissions.colSessionRev")}</th>
                <th className="py-1">{t("partner.commissions.colCommission")}</th>
                <th className="py-1">{t("partner.commissions.colStatus")}</th>
              </tr>
            </thead>
            <tbody>
              {commissions.data.entries.map((e) => (
                <tr key={e.id} className="border-t border-nb-border">
                  <td className="py-1.5 text-nb-text-2">
                    {formatDate(e.period_start)}
                  </td>
                  <td className="py-1.5 text-nb-text-2">
                    €{e.session_revenue_eur}
                  </td>
                  <td className="py-1.5 text-nb-text">€{e.commission_eur}</td>
                  <td className="py-1.5 text-nb-text-3">{e.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </>
  );
}
